import React, { Component } from "react";
import dayjs from "dayjs";

class MessageA2 extends Component {

    constructor(props) {
        super(props);
        this.linkRenderRef = React.createRef();
    }

    render() {
        let text      = (this.props.entry && this.props.entry.text) || "";
        return (
            <div className={this.messageContainerClassName()} style={this.messageContainerStyle()}>
                <div className={this.messageBoxClassName()} style={this.messageBoxStyle()}>
                    <div ref={this.linkRenderRef} />
                    <br />
                </div>
                { this.props.isLastEntry && this.props.sentTimestamp && <div className={this.messageTimeClassName()} style={this.messageTimeStyle()}>{dayjs.unix(Math.trunc(this.props.sentTimestamp/1000)).format("h:mm a")}</div>}
            </div>
        )
    }

    componentDidMount() {
        let text      = (this.props.entry && this.props.entry.text) || "";
        this.linkRenderRef.current.innerHTML = text;
    }

    messageTimeClassName = () => {
        return "s360-message-time-received";
        // switch (this.props.message.type) {
        //     // case MessageType.sent: return "s360-message-time-sent";
        //     // case MessageType.received: return "s360-message-time-received";
        //     // case MessageType.info: return "s360-message-time-info";
        //     default: return "";
        // }
    }

    messageBoxClassName = () => {
        return "s360-message-box-received";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-box-sent";
        //     case MessageType.received: return "s360-message-box-received";
        //     case MessageType.info: return "s360-message-box-info";
        //     default: return "";
        // }
    }

    messageContainerClassName = () => {
        return "s360-message-cotainer-received";
        // switch (this.props.message.type) {
        //     case MessageType.sent: return "s360-message-cotainer-sent";
        //     case MessageType.received: return "s360-message-cotainer-received";
        //     case MessageType.info: return "s360-message-cotainer-info";
        //     default: return "";
        // }
    }

    messageBoxStyle = () => {
        let config = this.props.config;
        return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.SenderMessageFont, fontSize: config.designDetails.SenderMessageFontSize, color: config.designDetails.senderMessageFontColor }
        // switch (this.props.message.type) {
        //     case MessageType.received: return { background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
        //     case MessageType.sent: return { background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }

    messageContainerStyle = () => {
        // let config = this.props.config
        return {}
    }

    messageTimeStyle = () => {
        let config = this.props.config;
        return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
        // switch (this.props.message.type) {
        //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
        //     default: return {}
        // }
    }

}

export default MessageA2;